import React from 'react';

const TransparencySlider = ({label, value, onChange}) => (
    <div style={{margin: '8px 0'}}>
        <label htmlFor={label}>
            {label}:
        </label>
        <input
            id={label}
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={value}
            onChange={(e) => onChange(parseFloat(e.target.value))}
            style={{
                accentColor: 'green',
                width: '100%',
                marginTop: '6px',
                appearance: 'none',
                height: '8px',
                borderRadius: '6px',
                background: `linear-gradient(to right, green ${value * 100}%, #e0e0e0 ${value * 100}%)`
            }}
        />
    </div>
);

export default TransparencySlider;
